export default __webpack_public_path__ + "static/media/booking-history.e2a579af.svg";